<!-- No Data State -->
<div class="no-data-state" *ngIf="releases?.length === 0" fxLayout="column" fxLayoutAlign="center center">
  <mat-icon class="no-data-icon">assessment</mat-icon>
  <h3>No Active Releases</h3>
  <p>There are no active releases available for this company.</p>
  <p class="date-hint">Please contact your administrator to create a release.</p>
</div>

<!-- Modern Dashboard -->
<div *ngIf="releases?.length > 0">
  <!-- Modern Dashboard Header -->
  <div class="dashboard-header" fxLayout="column" fxLayoutGap="20px">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
          <h1 class="dashboard-title">Release Issues Dashboard</h1>
          <mat-icon class="link" 
                    (click)="copyShareableUrl()" 
                    matTooltip="Copy shareable link to clipboard"
                    matTooltipPosition="below">
            share
          </mat-icon>
        </div>
        <h2 class="company-name">{{ selectedCompany?.name || selectedCompany?.code }}</h2>
        <h3 class="release-name" *ngIf="release">{{ release.name }}</h3>
      </div>
    </div>
    
    <div fxLayout="row" 
         fxLayout.lt-md="column" 
         fxLayoutAlign="end center" 
         fxLayoutAlign.lt-md="stretch start" 
         fxLayoutGap="16px" 
         fxLayoutGap.lt-md="12px" 
         style="margin-right: 0;">
      <!-- Release Selection -->
      <mat-form-field appearance="outline" 
                      class="release-selector"
                      fxFlex.lt-md="100">
        <mat-label>Select Release</mat-label>
        <mat-select [(ngModel)]="selectedReleaseId" (selectionChange)="onReleaseChange()">
          <mat-option *ngFor="let release of releases" [value]="release.id">
            {{release.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      
      <!-- Export Button -->
      <button mat-raised-button 
              color="primary" 
              fxFlex.lt-md="100"
              (click)="downloadCSV()" 
              style="margin-right: 0;">
        <mat-icon>download</mat-icon>
        Export
      </button>
    </div>
  </div>

  <!-- Dashboard Content -->
  <div class="dashboard-content" fxLayout="column" fxLayoutGap="16px">
    
    <!-- Key Metrics Row at Top -->
    <div class="metrics-sidebar">
      <div fxLayout="row wrap" 
           fxLayout.lt-md="column" 
           fxLayoutGap="16px"
           fxLayoutGap.lt-md="12px">
        <mat-card class="metric-card" fxFlex="1 1 calc(25% - 12px)" fxFlex.lt-md="1 1 calc(50% - 12px)" fxFlex.lt-sm="100">
          <mat-card-content fxLayout="column" fxLayoutAlign="center center">
            <div class="metric-value" [style.color]="'hsl(210, 90%, 55%)'">{{ totalHomes }}</div>
            <div class="metric-label">Total Homes</div>
            <div class="metric-subtitle">In this release</div>
          </mat-card-content>
        </mat-card>
        
        <mat-card class="metric-card" fxFlex="1 1 calc(25% - 12px)" fxFlex.lt-md="1 1 calc(50% - 12px)" fxFlex.lt-sm="100">
          <mat-card-content fxLayout="column" fxLayoutAlign="center center">
            <div class="metric-value" [style.color]="'hsl(330, 90%, 55%)'">{{ uniqueOpenIssues }}</div>
            <div class="metric-label">Open Issues</div>
            <div class="metric-subtitle">Currently unresolved</div>
          </mat-card-content>
        </mat-card>
        
        <mat-card class="metric-card" fxFlex="1 1 calc(25% - 12px)" fxFlex.lt-md="1 1 calc(50% - 12px)" fxFlex.lt-sm="100">
          <mat-card-content fxLayout="column" fxLayoutAlign="center center">
            <div class="metric-value" [style.color]="'hsl(145, 60%, 55%)'">{{ affectedHomes }}</div>
            <div class="metric-label">Affected Homes</div>
            <div class="metric-subtitle">With issues</div>
          </mat-card-content>
        </mat-card>
        
      </div>
      
      <!-- Second Row: Issue Activity Metrics -->
      <div fxLayout="row wrap" 
           fxLayout.lt-md="column" 
           fxLayoutGap="16px"
           fxLayoutGap.lt-md="12px">
        
        <mat-card class="metric-card" fxFlex="1 1 calc(25% - 12px)" fxFlex.lt-md="1 1 calc(50% - 12px)" fxFlex.lt-sm="100">
          <mat-card-content fxLayout="column" fxLayoutAlign="center center">
            <div class="metric-value" [style.color]="'hsl(190, 70%, 55%)'">{{ issuesUnassigned }}</div>
            <div class="metric-label">Unassigned</div>
            <div class="metric-subtitle">Need assignment</div>
          </mat-card-content>
        </mat-card>
        
        <mat-card class="metric-card" fxFlex="1 1 calc(25% - 12px)" fxFlex.lt-md="1 1 calc(50% - 12px)" fxFlex.lt-sm="100">
          <mat-card-content fxLayout="column" fxLayoutAlign="center center">
            <div class="metric-value" [style.color]="'hsl(60, 80%, 55%)'">{{ issuesOpenLast7Days }}</div>
            <div class="metric-label">Opened (7d)</div>
            <div class="metric-subtitle">New this week</div>
          </mat-card-content>
        </mat-card>
        
        <mat-card class="metric-card" fxFlex="1 1 calc(25% - 12px)" fxFlex.lt-md="1 1 calc(50% - 12px)" fxFlex.lt-sm="100">
          <mat-card-content fxLayout="column" fxLayoutAlign="center center">
            <div class="metric-value" [style.color]="'hsl(120, 60%, 55%)'">{{ issuesClosedLast7Days }}</div>
            <div class="metric-label">Closed (7d)</div>
            <div class="metric-subtitle">Resolved this week</div>
          </mat-card-content>
        </mat-card>

        <mat-card class="metric-card" fxFlex="1 1 calc(25% - 12px)" fxFlex.lt-md="1 1 calc(50% - 12px)" fxFlex.lt-sm="100">
          <mat-card-content fxLayout="column" fxLayoutAlign="center center">
            <div class="metric-value" [style.color]="'hsl(22, 82%, 55%)'">{{ homesRemainingPercentage }}%</div>
            <div class="metric-label">Progress</div>
            <div class="metric-subtitle">Completion rate</div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    
    <!-- Charts Layout -->
    <div class="charts-layout" fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="16px">
      <!-- Left Column: Two Charts Vertically -->
      <div class="left-column" fxFlex="50" fxLayout="column" fxLayoutGap="16px">
        <!-- Home Progress Chart -->
        <mat-card class="chart-card">
          <mat-card-header>
            <mat-card-title [style.color]="'hsl(210, 90%, 55%)'">Home Progress</mat-card-title>
            <mat-card-subtitle>Completion status overview</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content fxLayout="row" fxLayoutGap="12px">
            <div fxFlex="60" fxLayout="column" fxLayoutAlign="center center">
              <chart *ngIf="!homesProgressChartLoading"
                [type]="'pie'"
                [data]="homesProgressData"
                [labels]="homesProgressLabels"
                [colors]="homesProgressColors"
                [loading]="false"
                [slimMode]="true"
                [fillHeight]="false"
                [useCardWrapper]="false"
                [isDarkMode]="isDarkMode">
              </chart>
            </div>
            <div fxFlex="40" class="table-section" [style.--section-color]="'hsl(210, 90%, 55%)'">
              <h4 [style.color]="'hsl(210, 90%, 55%)'">Progress Details</h4>
              <div class="data-row">
                <span class="data-label">Total Homes:</span>
                <span class="data-value">{{ totalHomes }}</span>
              </div>
              <div class="data-row">
                <span class="data-label">Affected Homes:</span>
                <span class="data-value">{{ affectedHomes }}</span>
              </div>
              <div class="data-row highlight">
                <span class="data-label">Completion:</span>
                <span class="data-value">{{ homesRemainingPercentage }}%</span>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        
        <!-- Issue Status Chart -->
        <mat-card class="chart-card">
          <mat-card-header>
            <mat-card-title [style.color]="'hsl(330, 90%, 55%)'">Issue Status</mat-card-title>
            <mat-card-subtitle>Open vs closed issues</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content fxLayout="row" fxLayoutGap="12px">
            <div fxFlex="60" fxLayout="column" fxLayoutAlign="center center">
              <chart *ngIf="!issueChartLoading"
                [type]="'pie'"
                [data]="issueStatusData"
                [labels]="issueStatusLabels"
                [colors]="issueStatusColors"
                [loading]="false"
                [slimMode]="true"
                [fillHeight]="false"
                [isDarkMode]="isDarkMode"
                [useCardWrapper]="false"
                (chartClick)="handleChartClick($event)">
              </chart>
            </div>
            <div fxFlex="40" class="table-section" [style.--section-color]="'hsl(330, 90%, 55%)'">
              <h4 [style.color]="'hsl(330, 90%, 55%)'">Issue Breakdown</h4>
              <div class="data-row">
                <span class="data-label">Open Issues:</span>
                <span class="data-value">{{ uniqueOpenIssues }}</span>
              </div>
              <div class="data-row">
                <span class="data-label">Opened (7d):</span>
                <span class="data-value">{{ issuesOpenLast7Days }}</span>
              </div>
              <div class="data-row">
                <span class="data-label">Closed (7d):</span>
                <span class="data-value">{{ issuesClosedLast7Days }}</span>
              </div>
              <div class="data-row highlight">
                <span class="data-label">Unassigned:</span>
                <span class="data-value">{{ issuesUnassigned }}</span>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      
      <!-- Right Column: Priority and Categories Charts -->
      <div class="right-column" fxFlex="50" fxLayout="column" fxLayoutGap="16px">
        <!-- Issue Priority Chart -->
        <mat-card class="chart-card">
          <mat-card-header>
            <mat-card-title [style.color]="'hsl(145, 60%, 55%)'">Issue Priority</mat-card-title>
            <mat-card-subtitle>Priority distribution</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content fxLayout="row" fxLayoutGap="12px">
            <div fxFlex="60" fxLayout="column" fxLayoutAlign="center center">
              <chart *ngIf="!priorityTypesLoading"
                [type]="'pie'"
                [data]="priorityTypesData"
                [labels]="priorityTypesLabels"
                [colors]="priorityTypesColors"
                [loading]="priorityTypesLoading"
                [slimMode]="true"
                [useCardWrapper]="false"
                [isDarkMode]="isDarkMode"
                (chartClick)="onPriorityChartClick($event)">
              </chart>
            </div>
            <div fxFlex="40" class="table-section" [style.--section-color]="'hsl(145, 60%, 55%)'">
              <h4 [style.color]="'hsl(145, 60%, 55%)'">Priority Breakdown</h4>
              <div class="data-row" *ngFor="let label of priorityTypesLabels; let i = index">
                <span class="data-label">{{ label }}:</span>
                <span class="data-value">{{ priorityTypesData[0]?.data[i] || 0 }}</span>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        
        <!-- Issue Categories Chart -->
        <mat-card class="chart-card">
          <mat-card-header>
            <mat-card-title [style.color]="'hsl(30, 90%, 55%)'">Issue Categories</mat-card-title>
            <mat-card-subtitle>Category distribution</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content fxLayout="row" fxLayoutGap="12px">
            <div fxFlex="60" fxLayout="column" fxLayoutAlign="center center">
              <chart *ngIf="!releaseIssueCategoriesLoading"
                [type]="'pie'"
                [data]="releaseIssueCategoriesData"
                [labels]="releaseIssueCategoriesLabels"
                [colors]="releaseIssueCategoriesColors"
                [loading]="releaseIssueCategoriesLoading"
                [slimMode]="true"
                [useCardWrapper]="false"
                [isDarkMode]="isDarkMode"
                (chartClick)="onCategoryChartClick($event)">
              </chart>
            </div>
            <div fxFlex="40" class="table-section" [style.--section-color]="'hsl(30, 90%, 55%)'">
              <h4 [style.color]="'hsl(30, 90%, 55%)'">Category Breakdown</h4>
              <div class="data-row" *ngFor="let label of releaseIssueCategoriesLabels; let i = index">
                <span class="data-label">{{ label }}:</span>
                <span class="data-value">{{ releaseIssueCategoriesData[0]?.data[i] || 0 }}</span>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    
    <!-- Issue Types Distribution Chart (Full Width) -->
    <mat-card class="chart-card full-width-chart">
      <mat-card-header>
        <mat-card-title [style.color]="'hsl(280, 70%, 55%)'">Issue Types Distribution</mat-card-title>
        <mat-card-subtitle>Issues grouped by tags</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content fxLayout="row" fxLayoutGap="12px">
        <div fxFlex="60" fxLayout="column" fxLayoutAlign="center center">
          <chart *ngIf="!issueTypesLoading"
            [subtitle]="false"
            [type]="'horizontalBar'"
            [data]="issueTypesData"
            [labels]="issueTypesLabels"
            [colors]="issueTypesColors"
            [loading]="false"
            [slimMode]="true"
            [useCardWrapper]="false"
            [labelFormatter]="labelFormatter"
            [isDarkMode]="isDarkMode"
            (chartClick)="onTagChartClick($event)">
          </chart>
        </div>
        <div fxFlex="40" class="table-section" [style.--section-color]="'hsl(280, 70%, 55%)'">
          <h4 [style.color]="'hsl(280, 70%, 55%)'">Issue Types Breakdown</h4>
          <div class="data-row highlight">
            <span class="data-label">Total Tags:</span>
            <span class="data-value">{{ getTotalIssueCount() }}</span>
          </div>
          <div class="data-row" *ngFor="let label of issueTypesLabels; let i = index">
            <span class="data-label">{{ label }}:</span>
            <span class="data-value">{{ issueTypesData[0]?.data[i] || 0 }}</span>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Houses Report Table -->
  <mat-card class="chart-card" style="margin-top: 32px;">
    <mat-card-header>
      <mat-card-title [style.color]="'hsl(280, 70%, 55%)'">Houses Report</mat-card-title>
      <mat-card-subtitle>Issue breakdown by home</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="table-container">
        <table mat-table [dataSource]="houseReportDataSource" matSort class="houses-table">
          <!-- Home Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Home</th>
            <td mat-cell *matCellDef="let row">
              <a class="home-link" (click)="onHomeClick(row.name)" [class.active]="homeFilter === row.name">
                {{row.name}}
              </a>
            </td>
          </ng-container>
    
          <!-- Total Issues Column -->
          <ng-container matColumnDef="totalIssues">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Issues</th>
            <td mat-cell *matCellDef="let row">{{row.totalIssues}}</td>
          </ng-container>
    
          <!-- Dynamic Tag Columns -->
          <ng-container *ngFor="let tag of tagColumns" [matColumnDef]="tag">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{tag}} Issues</th>
            <td mat-cell *matCellDef="let row">{{ getTagCount(row, tag) }}</td>
          </ng-container>
    
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Issues List Section -->
  <mat-card class="chart-card" style="margin-top: 32px;">
    <mat-card-header>
      <mat-card-title [style.color]="'hsl(210, 90%, 55%)'">Release Issues</mat-card-title>
      <mat-card-subtitle>{{ filteredReleaseIssues?.length ?? 0 }} issues in this release</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <!-- Search and Filters -->
      <div fxLayout="column" fxLayoutGap="20px">
        <!-- Search Bar -->
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Search Issues</mat-label>
          <input matInput type="text"
            [formControl]="searchReleaseIssuesField"
            (keyup)="doReleaseIssueFilter($event.target.value); updateParams()"
            (keyup.esc)="$event.target.value=''; doReleaseIssueFilter(''); updateParams()"
            placeholder="Search all {{ filteredReleaseIssues?.length ?? 0 }} release issues">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <!-- Filter Pills -->
        <div class="filter-section">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px" fxLayoutWrap>
            <small class="filter-label">Filters:</small>
            <small *ngIf="priorityFilter === undefined &&
              statusFilter === undefined &&
              !createdFilter &&
              !assignedFilter &&
              categoryFilter === undefined &&
              !tagFilter &&
              !homeFilter &&
              !selectedReleaseIssue &&
              !showMyIssuesOnly &&
              !showOpenIssuesOnly" class="no-filters">
              no filters currently applied
            </small>
            <mat-chip-list>
              <!-- Permanent Filter Pills -->
              <mat-chip 
                [color]="showOpenIssuesOnly ? 'primary' : 'default'"
                (click)="toggleOpenIssuesFilter()">
                <mat-icon>{{showOpenIssuesOnly ? 'check_circle' : 'radio_button_unchecked'}}</mat-icon>
                Open Issues Only
              </mat-chip>
              <mat-chip 
                [color]="showMyIssuesOnly ? 'primary' : 'default'"
                (click)="toggleMyIssuesFilter()">
                <mat-icon>{{showMyIssuesOnly ? 'check_circle' : 'radio_button_unchecked'}}</mat-icon>
                My Issues
              </mat-chip>
              
              <!-- Dynamic Filter Chips -->
              <mat-chip *ngIf="priorityFilter !== undefined" color="accent">
                <span>Priority: {{ getPriority(priorityFilter) }}</span>
                <button matChipRemove>
                  <mat-icon color="primary" matTooltip="Clear filter" (click)="clearPriorityFilter()">clear</mat-icon>
                </button>
              </mat-chip>
              <mat-chip *ngIf="statusFilter !== undefined" color="accent">
                <span>Status: {{ releaseIssueStatuses[statusFilter] }}</span>
                <button matChipRemove>
                  <mat-icon color="primary" matTooltip="Clear filter" (click)="clearStatusFilter()">clear</mat-icon>
                </button>
              </mat-chip>
              <mat-chip *ngIf="createdFilter" color="accent">
                <span>Created By: {{ createdFilter }}</span>
                <button matChipRemove>
                  <mat-icon color="primary" matTooltip="Clear filter" (click)="onCardCreatedClick(undefined)">clear</mat-icon>
                </button>
              </mat-chip>
              <mat-chip *ngIf="assignedFilter" color="accent">
                <span>Assigned To: {{ assignedFilter }}</span>
                <button matChipRemove>
                  <mat-icon color="primary" matTooltip="Clear filter" (click)="onCardAssignedClick(undefined)">clear</mat-icon>
                </button>
              </mat-chip>
              <mat-chip *ngIf="categoryFilter !== undefined" color="accent">
                <span>Category: {{ getCategory(categoryFilter) }}</span>
                <button matChipRemove>
                  <mat-icon color="primary" matTooltip="Clear filter" (click)="clearCategoryFilter()">clear</mat-icon>
                </button>
              </mat-chip>
              <mat-chip *ngIf="tagFilter" color="accent">
                <span>Tag: {{ tagFilter }}</span>
                <button matChipRemove>
                  <mat-icon color="primary" matTooltip="Clear filter" (click)="clearTagFilter()">clear</mat-icon>
                </button>
              </mat-chip>
              <mat-chip *ngIf="homeFilter" color="accent">
                <span>Home: {{ homeFilter }}</span>
                <button matChipRemove>
                  <mat-icon color="primary" matTooltip="Clear filter" (click)="clearHomeFilter()">clear</mat-icon>
                </button>
              </mat-chip>
              <mat-chip *ngIf="selectedReleaseIssue" color="accent">
                <span>In focus Issue</span>
                <button matChipRemove>
                  <mat-icon color="primary" matTooltip="Clear filter" (click)="clearFocusFilter()">clear</mat-icon>
                </button>
              </mat-chip>
            </mat-chip-list>
          </div>
        </div>

        <!-- Issue Cards -->
        <div class="issues-container">
          <ng-container *ngFor="let item of filteredReleaseIssues; let i=index">
            <release-issue-card
              [item]="item"
              [companyId]="selectedCompany?.id"
              [hideEdit]="hideEdit"
              [searchTerm]="searchReleaseIssuesField?.value"
              [isSelectable]="true"
              [selectedCard]="selectedCard ?? selectedReleaseIssue"
              [productName]="productName"
              (onEdit)="onEdit($event)"
              (onSelectClick)="onCardSelectClick($event)"
              (onPriorityClick)="onCardPriorityClick($event)"
              (onStatusClick)="onCardStatusClick($event)"
              (onCreatedClick)="onCardCreatedClick($event)"
              (onAssignedClick)="onCardAssignedClick($event)"
              (onIssueLoadClick)="onCardIssueLoadClick($event)">
            </release-issue-card>
            <tag-picker
              (addTagRequest)="addTag($event, item)"
              (removeTagRequest)="removeTag($event, item)"
              [allTags]="tags"
              [assignedTagIds]="getAssignedTagIds(item)"
              [resourceType]="resourceTypeEnum"
              [allowAddTag]="false">
            </tag-picker>
          </ng-container>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>